import { Button, Form, Modal } from "antd";
import { Rule, RuleUIAction, RuleUICondition } from "models/rules";
import { useEffect, useState } from "react";
import NewRuleForm from "./NewRuleForm";

interface NewRuleModalProps {
    onRuleCreated: (rule: Rule) => Promise<void>;
}

const NewRuleModal = ({ onRuleCreated }: NewRuleModalProps) => {
    const [open, setOpen] = useState(false);
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [form] = Form.useForm<Rule>();

    // for some reason, the form doesn't properly reset after saving a rule, so reset the form
    // again when the modal is opened
    useEffect(() => {
        if (open) {
            form.resetFields();
        }
    }, [open, form]);

    const resetForm = () => {
        form.resetFields();
    }

    const closeAndReset = () => {
        resetForm();
        setOpen(false);
    }

    const onFormUpdate = (conditions: RuleUICondition[], action: RuleUIAction) => {
        setSaveDisabled(conditions.length === 0 || action === RuleUIAction.Unknown);
    }

    return <>
        <Button type="primary" onClick={() => setOpen(true)}>Create New Rule</Button>
        <Modal
            title="Create New Rule"
            width='700px'
            open={open}
            onCancel={closeAndReset}
            onOk={async () => {
                const rule = await form.validateFields();
                await onRuleCreated(rule);
                closeAndReset();
            }}
            okButtonProps={{ disabled: saveDisabled }}
            closable={false}
            maskClosable={false}
            destroyOnClose
            keyboard={false}
        >
            <NewRuleForm form={form} onChange={onFormUpdate} />
        </Modal>
    </>
};

export default NewRuleModal;